import { pagePath, } from '#src/app/navigation/module.js';
/** Módulos com as páginas que a pessoa pode abrir. Módulo sem página some. */
export function visibleModules(modules, can) {
    return modules
        .map((module) => ({
        module,
        pages: module.pages.filter((page) => can(page.permission)),
    }))
        .filter(({ pages }) => pages.length > 0);
}
/** `perfis/:code` casa com `perfis/admin`: cada parâmetro vale um segmento. */
function matchesPattern(pattern, path) {
    const expected = pattern.split('/');
    const actual = path.split('/');
    return (expected.length === actual.length &&
        expected.every((segment, index) => segment.startsWith(':') || segment === actual[index]));
}
/** Módulo e página de um endereço, para o breadcrumb e o item selecionado. */
export function findRoute(modules, pathname) {
    const module = modules.find((candidate) => pathname === `/${candidate.path}` ||
        pathname.startsWith(`/${candidate.path}/`));
    if (module === undefined) {
        return undefined;
    }
    const page = module.pages.find((candidate) => {
        const path = pagePath(module, candidate);
        return pathname === path || pathname.startsWith(`${path}/`);
    });
    const relative = pathname.slice(module.path.length + 2);
    const route = module.routes?.find((candidate) => matchesPattern(candidate.path, relative));
    return { module, page, route };
}
/**
 * As telas (páginas e rotas internas) que exigem a permissão para abrir.
 */
export function screensRequiring(modules, permission) {
    return modules.flatMap((module) => [
        ...module.pages
            .filter((page) => page.permission === permission)
            .map((page) => ({
            path: pagePath(module, page),
            label: `${module.title} > ${page.title}`,
        })),
        ...(module.routes ?? [])
            .filter((route) => route.permission === permission)
            .map((route) => ({
            path: `/${module.path}/${route.path}`,
            label: `${module.title} > ${route.title}`,
        })),
    ]);
}
//# sourceMappingURL=navigation.js.map